module.exports = __webpack_public_path__ + "static/bowlaway-39b2a64c4196dcfac75b5f96eeb2abf7.jpg";